<div fxLayout="column">
  <div *ngIf="attachmentsLoading" fxLayout="row" fxLayoutAlign="center center" class="mb-5">
    <mat-spinner diameter="35"></mat-spinner>
  </div>
  <ng-container *ngIf="attachments?.length">
    <mmx-auth-attachments-table
      [attachments]="attachments"
      (delete)="onDeleteAttachments($event)"
    >
    </mmx-auth-attachments-table>

    <mat-divider class="mb-5"></mat-divider>
  </ng-container>

  <p class="text-center">
    {{ 'patient-details.authorization-card.attachments.upload-hint' | translate }}
  </p>
  <div class="mb-5">
    <div *ngIf="hasFiles$ | async">
      <form [fromGroup]="formGroup">
        <div
          *ngFor="let item of files$ | async; let i = index"
          fxLayout="row"
          fxLayoutAlign="center center"
          class="mb-2"
        >
        <div fxFlex>
          <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
            <mat-icon>description</mat-icon>
            <div fxFlex>
              {{ item.value.file.name }} <small>{{ item.value.file.type }}</small>
            </div>
          </div>
        </div>
          <form [formGroup]="formGroup.get(item.key)">

            <span style="flex: 1 1 auto"></span>

            <mat-form-field class="document-type-field">
              <mat-label>{{ 'patient-details.authorization-card.attachments.document-type' | translate }}</mat-label>
              <mat-select formControlName="documentType">
                <mat-option *ngFor="let type of documentTypes" [value]="type.value">
                  {{ type.viewValue | translate }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </form>
        </div>
      </form>
    </div>

    <div>
      <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px">
        <mmx-file-uploader
          [label]="(fileUploaderLabel$ | async) | translate"
          [maxSize]="5"
          [fileSizeError]="'patient-details.authorization-card.attachments.file-size-limit' | translate"
          [disabled]="documentsUploading$ | async"
          (fileUploaded)="onFileSelected($event)"
        ></mmx-file-uploader>

        <ng-container *ngIf="hasFiles$ | async">
          <button
            mat-raised-button
            color="primary"
            [disabled]="isUploadButtonDisabled$ | async"
            (click)="onUploadFiles()"
          >
            {{ 'patient-details.authorization-card.attachments.upload' | translate }}
          </button>
        </ng-container>
      </div>
    </div>
  </div>
</div>
